import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = ({
  alternateLanguages,
  navigation,
  settings,
  children
}) => {
  // type = 'navigation' for header nav items
  // type = 'navigation_footer for footer nav items
  const getNav = (type) => {
    return Object.keys(navigation.data)
      .reduce((arr, x) => arr.concat(navigation.data[x]), [])
      .filter((x) => x.slice_type === type);
  };

  const headerNav = getNav('navigation');
  const footerNav = getNav('navigation_footer');
  const footerCTAs = getNav('call_to_action');

  return (
    <>
      <Header alternateLanguages={alternateLanguages} items={headerNav} />
      <main>{children}</main>
      <Footer
        settings={settings}
        ctas={footerCTAs}
        items={footerNav}
        text={navigation.data.footer_text}
      />
    </>
  );
};
